import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Pipe({
    name: 'sanitizeURL',
    standalone: false
})
export class SanitizeURLPipe implements PipeTransform {

    constructor(
        private readonly _sanitizer: DomSanitizer
    ) { }
    
    transform(url: string): SafeUrl {
        return this._sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
